import React from 'react';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../hooks/useAuth';
import InboxMessageDetail from './my-inbox-detail';
import { Fab } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';


function InboxMessage() {
    const { authData, authDataLang } = useAuth()
    const navigate = useNavigate()

    const handleSendInbox=() =>{
        navigate('/send-inbox')
    }
    // const [myInbox, setMyInbox] = useState(null)
    // const [error, setError] = useState(false)
    // const [loading, setLoding] = useState(false)
    // const [countShow, setCountShow] = useState(10)
    // const [defPage, setDefPage] = useState(1)
    // const [searchFact, setSearchFact] = useState('')

    // useEffect(()=>{
    //     window.scrollTo(0, 200)
    //     setLoding(true)
    //     const getData = async() =>{
    //         await getInbox(authData.token, defPage, countShow, searchFact)
    //         .then(data => {
    //             setMyInbox(data)
    //             console.log(data)
    //             setLoding(false)
    //         }).catch( e => {
    //             setError(true)
    //             setLoding(false)
    //         })
    //     }
    //     getData()
    // }, [])

    // // if (error) return <h1> Error </h1> 
    // if (loading) return <ProgressWait statusWait={true}/> 
  
  return (
    <React.Fragment>
        <div style={{width: '100%', minHeight: 1000}} dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
            <br/>
            <Fab variant="extended" 
                size="small" color="secondary" 
                aria-label="add" 
                sx={{
                    textAlign: 'right',
                }}
                onClick={handleSendInbox}
                >
                <SendIcon sx={{ mr: 1 }} />
                <Typography
                    fontFamily='b_mitra' 
                    component="div"
                    variant="h6"
                    >
                    {authDataLang?.site_langs?.desc_menu_msg_send}
                </Typography>
            </Fab>
            <Paper square sx={{ display: 'block', overflow: 'auto', margin: 'auto' }}>
              <Typography variant="h5" gutterBottom component="div" sx={{ p: 2, pb: 0 }}>
                  {/* <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}> */}
                      <h3 style={{fontFamily: 'b_mitra'}}>
                          {authDataLang?.site_langs?.desc_menu_msg}:
                      </h3>
                  {/* </div> */}
              </Typography>

              {authData &&
                  <div >
                      <InboxMessageDetail />
                  </div>
                }
            </Paper>
        </div>
    </React.Fragment>
  )
}

export default InboxMessage
